import * as jsxRuntime from "/Users/erosbla/Desktop/telegram-miniapp-menu/apps/miniapp-web/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment